module.exports = __webpack_public_path__ + "assets/img/11.532d5078.png";